/* tslint:disable */
/* eslint-disable */
/**
 * DEX API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
/**
 *
 * @export
 * @interface ReferralInfo
 */
export interface ReferralInfo {
  /**
   * This is timestamp that shows when user was registered
   * @type {number}
   * @memberof ReferralInfo
   */
  registered?: number
  /**
   *
   * @type {number}
   * @memberof ReferralInfo
   */
  userId?: number
  /**
   *
   * @type {string}
   * @memberof ReferralInfo
   */
  team?: ReferralInfoTeamEnum
  /**
   *
   * @type {number}
   * @memberof ReferralInfo
   */
  totalTradingVolume?: number
  /**
   *
   * @type {number}
   * @memberof ReferralInfo
   */
  totalLiquidityInUsd?: number
  /**
   * Assets locked in launchpools
   * @type {number}
   * @memberof ReferralInfo
   */
  totalLockedInUsd?: number
  /**
   * Total amount of NMX that referral has earned via bonuses program
   * @type {number}
   * @memberof ReferralInfo
   */
  totalEarned?: number
}

/**
 * @export
 * @enum {string}
 */
export enum ReferralInfoTeamEnum {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export function ReferralInfoFromJSON(json: any): ReferralInfo {
  return ReferralInfoFromJSONTyped(json, false)
}

export function ReferralInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReferralInfo {
  if (json === undefined || json === null) {
    return json
  }
  return {
    registered: !exists(json, 'registered') ? undefined : json['registered'],
    userId: !exists(json, 'userId') ? undefined : json['userId'],
    team: !exists(json, 'team') ? undefined : json['team'],
    totalTradingVolume: !exists(json, 'totalTradingVolume') ? undefined : json['totalTradingVolume'],
    totalLiquidityInUsd: !exists(json, 'totalLiquidityInUsd') ? undefined : json['totalLiquidityInUsd'],
    totalLockedInUsd: !exists(json, 'totalLockedInUsd') ? undefined : json['totalLockedInUsd'],
    totalEarned: !exists(json, 'totalEarned') ? undefined : json['totalEarned'],
  }
}

export function ReferralInfoToJSON(value?: ReferralInfo | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    registered: value.registered,
    userId: value.userId,
    team: value.team,
    totalTradingVolume: value.totalTradingVolume,
    totalLiquidityInUsd: value.totalLiquidityInUsd,
    totalLockedInUsd: value.totalLockedInUsd,
    totalEarned: value.totalEarned,
  }
}
